// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { auditEventsResponseSchema } from '@/audit/api/types';

/**
 * Request a list of audit events for a person from the remote API.
 *
 * @param key - The key of the person for which to request audit events.
 */
export async function getPersonAuditEvents(key: string) {
  const url = `/v1/person/${key}/audit`;
  const response = await api.get(url);

  return parseResponse(auditEventsResponseSchema, response.data, {
    schemaName: 'PersonAuditEvents',
    endpoint: url,
  });
}
